export default __webpack_public_path__ + "static/media/test-assignment-sante24-hero-de.a19affba.png";